import script from "./EUserDetailCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EUserDetailCard.vue?vue&type=script&setup=true&lang=ts"

import "./EUserDetailCard.vue?vue&type=style&index=0&id=7f982c60&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f982c60"]])

export default __exports__